module.exports = __webpack_public_path__ + "img/events.722d28fc.png";